export const APP_VERSION="v0.2.0_rc168_cx | 533262960e098ffda4d73605dbfcbdbbd2f1ae84"
